export const LANGUAGE_STORAGE_KEY = "app-language";

export const translations = {
  en: {
    Dashboard: "Dashboard",
    Dashboards: "Dashboards",
    Monitorings: "Monitorings",
    "Project Manager": "Project Manager",
    "Project Runtime": "Project Runtime",
    "Runtime Diagnostics": "Runtime Diagnostics",
    Screens: "Screens",
    Reports: "Reports",
    History: "History",
    Records: "Records",
    "Alarm Manager": "Alarm Manager",
    "Alert Manager": "Alarm Manager",
    Manual: "Manual",
    Settings: "Settings",
    Connections: "Connections",
    "Tag Groups": "Tag Groups",
    Accounts: "Accounts",
    System: "System",
    Alarms: "Alarms",
    Alerts: "Alarms",
    alarms: "alarms",
    alerts: "alarms",
    dashboard: "dashboard",
    history: "history",
    records: "records",
    manual: "manual",
    connections: "connections",
    "tag groups": "tag groups",
    accounts: "accounts",
    system: "system",
    "alarm reports": "alarm reports",
    "alert reports": "alarm reports",
    "Alert Reports": "Alarm Reports",
    Alert: "Alarm",
    "Alert:": "Alarm:",
    State: "State",
    "State:": "State:",
    Started: "Started",
    Ended: "Ended",
    Viewed: "Viewed",
    Duration: "Duration",
    Total: "Total",
    Active: "Active",
    Summary: "Summary",
    "Active Alerts": "Active Alarms",
    "All Active Alerts": "All Active Alarms",
    "Alert History": "Alarm History",
    "Alert Summary": "Alarm Summary",
    "Filter by alert": "Filter by alarm",
    "Click one alert row to filter its history": "Click one alarm row to filter its history",
    "Alert Detail": "Alarm Detail",
    "Start value:": "Start value:",
    "End value:": "End value:",
    "Start data:": "Start data:",
    "End data:": "End data:",
    "Historical Alert Type": "Historical Alarm Type",
    "Historical Alert Tag": "Historical Alarm Tag",
    "Historical Configuration": "Historical Configuration",
    "Marked as viewed": "Marked as viewed",
    Note: "Note",
    "Unable to load alert detail": "Unable to load alarm detail",
    "Alert record updated": "Alarm record updated",
    "Alert records cleared": "Alarm records cleared",
    "Unable to update alert record": "Unable to update alarm record",
    "Unable to clear alert records": "Unable to clear alarm records",
    "load failed": "load failed",
    "update failed": "update failed",
    "update succeeded": "update succeeded",
    "Alert Types": "Alarm Types",
    "Alert Tags": "Alarm Tags",
    "Alert Type": "Alarm Type",
    "Alert Tag": "Alarm Tag",
    Language: "Language",
    English: "English",
    Vietnamese: "Vietnamese",
    "Hi,": "Hi,",
    "Loading...": "Loading...",
    "New Type": "New Type",
    "New Alert Tag": "New Alarm Tag",
    "Create a new alert type, then open it to configure values and states.":
      "Create a new alarm type, then open it to configure values and states.",
    "Please input data for new alert tag": "Please input data for new alarm tag",
    "Please input data for new tag": "Please input data for new tag",
    "BASIC INFORMATION": "BASIC INFORMATION",
    Close: "Close",
    Save: "Save",
    Name: "Name",
    Description: "Description",
    "Filter Name": "Filter Name",
    "Filter Alert Type": "Filter Alarm Type",
    "Search by name": "Search by name",
    Search: "Search",
    "All Alert Types": "All Alarm Types",
    "Select alert type": "Select alarm type",
    "Source Tag": "Source Tag",
    Tag: "Tag",
    "Tag Group": "Tag Group",
    "All Tag Groups": "All Tag Groups",
    "Select source tag": "Select source tag",
    "Select tag": "Select tag",
    "Save Alert Tag": "Save Alarm Tag",
    Versions: "Versions",
    Version: "Version",
    "Created At": "Created At",
    "Tag Versions": "Tag Versions",
    Current: "Current",
    Unused: "Unused",
    "In use": "In use",
    "Delete version": "Delete version",
    "This version is still in use": "This version is still in use",
    "Are you sure you want to delete this version?": "Are you sure you want to delete this version?",
    "Alert type version deleted": "Alarm type version deleted",
    "Unable to delete alert type version": "Unable to delete alarm type version",
    "Alert tag version deleted": "Alarm tag version deleted",
    "Unable to delete alert tag version": "Unable to delete alarm tag version",
    "Old versions can be deleted only when they are no longer referenced by alert records or alert tag versions.":
      "Old versions can be deleted only when they are no longer referenced by alarm records or alarm tag versions.",
    "Old versions can be deleted only when they are no longer referenced by alert records.":
      "Old versions can be deleted only when they are no longer referenced by alarm records.",
    "Alert Type Version": "Alarm Type Version",
    "Loading alert tag...": "Loading alarm tag...",
    "Loading alert type...": "Loading alarm type...",
    "Loading alert settings...": "Loading alarm settings...",
    "Current State": "Current State",
    Inactive: "Inactive",
    Normal: "Normal",
    "matched states": "matched states",
    states: "states",
    Action: "Action",
    Delete: "Delete",
    "Are you sure you want to delete alert type with Name:":
      "Are you sure you want to delete alarm type with Name:",
    "Are you sure you want to delete alert tag with Name:":
      "Are you sure you want to delete alarm tag with Name:",
    Edit: "Edit",
    "Compare Values": "Compare Values",
    "Source Tags": "Source Tags",
    States: "States",
    "Click one alert type to open its own page for compare values, states, and simulation.":
      "Click one alarm type to open its own page for compare values, states, and simulation.",
    "Tạo alert tag cơ bản trước, sau đó bấm vào từng dòng để cấu hình tag group, tag nguồn, và các thông số.":
      "Create the basic alarm tag first, then open a row to configure tag group, source tag, and alarm parameters.",
    "1. Thông tin cơ bản": "1. Basic information",
    "2. Alert parameters": "2. Alarm parameters",
    "2. Source Tag": "2. Source Tag",
    "3. Thông số cảnh báo": "3. Alarm parameters",
    "Chọn tag group, source tag, và các thông số so sánh cho cảnh báo này.":
      "Select tag group, source tag, and comparison parameters for this alarm.",
    "Alert output tag đã được tạo tự động trong nhóm `Alerts`. Ở đây bạn chọn tag nguồn để so sánh.":
      "The alarm output tag is created automatically in the `Alarms` group. Select the source tag here for comparison.",
    "Các giá trị bên dưới sẽ được dùng trong condition của alert type đã chọn.":
      "The values below will be used in the condition of the selected alarm type.",
    "Alert type này hiện chưa có compare values.":
      "This alarm type does not have compare values yet.",
    "Enter alert tag name": "Enter alarm tag name",
    "Enter alert type name": "Enter alarm type name",
    "Enter description": "Enter description",
    "1. Tạo giá trị để so sánh": "1. Create compare values",
    "2. Tạo States": "2. Create states",
    "3. Giả lập ngõ ra": "3. Simulate output",
    Key: "Key",
    Order: "Order",
    Message: "Message",
    Color: "Color",
    Condition: "Condition",
    "No description": "No description",
    "Add Value": "Add Value",
    "Add Tag": "Add Tag",
    "Add Compare": "Add Compare",
    "Update Compare": "Update Compare",
    "Save Values": "Save Values",
    "Save Changes": "Save Changes",
    "Update State": "Update State",
    "Create State": "Create State",
    "Cancel Edit": "Cancel Edit",
    "Please create or cancel the current state before saving changes.":
      "Please create or cancel the current state before saving changes.",
    "Please add or cancel the current compare before saving changes.":
      "Please add or cancel the current compare before saving changes.",
    "Unsaved changes": "Unsaved changes",
    "You have unsaved changes. Continue without saving?": "You have unsaved changes. Continue without saving?",
    Stay: "Stay",
    Continue: "Continue",
    "Current Output": "Current Output",
    Matched: "Matched",
    "No active state.": "No active state.",
    "Allowed params:": "Allowed params:",
    "Operators:": "Operators:",
    "Condition error:": "Condition error:",
    "Condition references a key that does not exist:": "Condition references a key that does not exist:",
    "Each compare value is used in state conditions and in the Alert Tag form.":
      "Each compare value is used in state conditions and in the Alarm Tag form.",
    "Value inputs are entered manually in Alert Tag. Tag inputs let the user choose a real tag and expose its value by key in conditions.":
      "Value inputs are entered manually in Alarm Tag. Tag inputs let the user choose a real tag and expose its value by key in conditions.",
    "Keys can only use letters, numbers, hyphens, and underscores. Example: `high`, `critical_1`, `limit-max`.":
      "Keys can only use letters, numbers, hyphens, and underscores. Example: `high`, `critical_1`, `limit-max`.",
    "Key `value` is reserved for source tag data and cannot be used as a compare value.":
      "Key `value` is reserved for source tag data and cannot be used as a compare value.",
    "Conditions can use the keys created above. The first matching state becomes the active output.":
      "Conditions can use the keys created above. The first matching state becomes the active output.",
    "Conditions can use the keys created above. Any matching state will be shown in the simulation output.":
      "Conditions can use the keys created above. Any matching state will be shown in the simulation output.",
    "Example: High Value": "Example: High Value",
    "Example: Temperature Tag": "Example: Temperature Tag",
    "Example: high": "Example: high",
    "Example: temperature": "Example: temperature",
    "Example: Temperature is above threshold": "Example: Temperature is above threshold",
    "Example: `temperature > high && pressure < critical`": "Example: `temperature > high && pressure < critical`",
    "Example: temperature > high && pressure < critical": "Example: temperature > high && pressure < critical",
    "Enter values for the inputs below to see which state becomes active.":
      "Enter values for the inputs below to see which state becomes active.",
    "Configure numeric values and source tags for each key used by this alert type.":
      "Configure numeric values and source tags for each key used by this alarm type.",
    "Alert type must include at least one tag input.": "Alarm type must include at least one tag input.",
    "Please enter a key for at least one tag input.": "Please enter a key for at least one tag input.",
    "Please select all required tags.": "Please select all required tags.",
    "Needs update": "Needs update",
    "Alert type updated. Related alert tags were disabled and need review before alerts work again.":
      "Alarm type updated. Related alarm tags were disabled and need review before alarms work again.",
    "This alert tag is disabled and must be reviewed before alerts work again.":
      "This alarm tag is disabled and must be reviewed before alarms work again.",
    "Please review the parameters below and save again to reactivate this alert tag.":
      "Please review the parameters below and save again to reactivate this alarm tag.",
    create: "create",
    update: "update",
    detail: "detail",
    "display profiles": "display profiles",
    "Display Profiles": "Display Profiles",
    Create: "Create",
    Update: "Update",
    Cancel: "Cancel",
    All: "All",
    Yes: "Yes",
    No: "No",
    Tags: "Tags",
    Connections: "Connections",
    Connection: "Connection",
    Port: "Port",
    Type: "Type",
    Status: "Status",
    "Status At": "Status At",
    "Data Key": "Data Key",
    "Data Key Enabled": "Data Key Enabled",
    Enabled: "Enabled",
    Disabled: "Disabled",
    "BG Image": "BG Image",
    "Protocol (Method)": "Protocol (Method)",
    "Protocol (Methods)": "Protocol (Methods)",
    "Select Port": "Select Port",
    "Select Type": "Select Type",
    "Select Column": "Select Column",
    "Select Connection": "Select Connection",
    "Select Tag": "Select Tag",
    "Select Tag Group": "Select Tag Group",
    "Select tag group": "Select tag group",
    "Select tags": "Select tags",
    "Select tag group first": "Select tag group first",
    "Type here to search...": "Type here to search...",
    "Columns Filter": "Columns Filter",
    Value: "Value",
    Time: "Time",
    "Date Time": "Date Time",
    "Connections Management": "Connections Management",
    "Tag Groups Management": "Tag Groups Management",
    "Modbus TCP, RTU connections": "Modbus TCP, RTU connections",
    "Groups,Tags": "Groups,Tags",
    "NEW CONNECTION": "NEW CONNECTION",
    "Create Connection": "Create Connection",
    "Please provide data for new connection": "Please provide data for new connection",
    "NEW TAG GROUP": "NEW TAG GROUP",
    "Please input data for new tag group": "Please input data for new tag group",
    "Enter name": "Enter name",
    "Enter description": "Enter description",
    "Enter host": "Enter host",
    "Enter data key": "Enter data key",
    "Select Connection Type": "Select Connection Type",
    "Slave Id": "Slave Id",
    "TCP Host": "TCP Host",
    "TCP Port": "TCP Port",
    "Poll Time": "Poll Time",
    "Connect And Read Timeout (s)": "Connect And Read Timeout (s)",
    "Block Reading Max Size": "Block Reading Max Size",
    "DELETE CONNECTION": "DELETE CONNECTION",
    "DELETE TAG": "DELETE TAG",
    "Are you sure you want to delete connection with Name:":
      "Are you sure you want to delete connection with Name:",
    "Are you sure you want to delete tag group with Name:":
      "Are you sure you want to delete tag group with Name:",
    online: "online",
    offline: "offline",
    unknown: "unknown",
    Monitorings: "Monitorings",
    MONITORINGS: "MONITORINGS",
    "Data Key": "Data Key",
    "BG Image": "BG Image",
    History: "History",
    HISTORY: "HISTORY",
    Records: "Records",
    RECORDS: "RECORDS",
    "USAGE RECORDS": "USAGE RECORDS",
    "GRID DATA": "GRID DATA",
    "Data Buckets": "Data Buckets",
    "No bucket": "No bucket",
    "Chart View": "Chart View",
    "Grid View": "Grid View",
    "Delete Searched Range": "Delete Searched Range",
    "Delete searched history records?": "Delete searched history records?",
    "This action permanently deletes history records for the selected tags in the selected time range.":
      "This action permanently deletes history records for the selected tags in the selected time range.",
    "Loaded bucket records:": "Loaded bucket records:",
    "Record counts will refresh after deletion. Empty storage segments are removed so disk usage can shrink.":
      "Record counts will refresh after deletion. Empty storage segments are removed so disk usage can shrink.",
    "Type DELETE to confirm.": "Type DELETE to confirm.",
    "Delete Records": "Delete Records",
    "Selected range:": "Selected range:",
    "loaded bucket records": "loaded bucket records",
    "Max selection: 16 Tags": "Max selection: 16 Tags",
    "Clear All": "Clear All",
    "Clear Before": "Clear Before",
    "clearing...": "clearing...",
    "EST: 10m": "EST: 10m",
    "CLEAR RECORDS": "CLEAR RECORDS",
    "Are you sure you want to clear all records of:":
      "Are you sure you want to clear all records of:",
    "Are you sure you want to clear records before time of:":
      "Are you sure you want to clear records before time of:",
    "Total Rows:": "Total Rows:",
    "There are no rows please select tag and fetch data first":
      "There are no rows please select tag and fetch data first",
    "Records Total": "Records Total",
    Communications: "Communications",
    Interfaces: "Interfaces",
    Protocol: "Protocol",
    "MQTT Profiles": "MQTT Profiles",
    "Send Profiles": "Send Profiles",
    "Receive Profiles": "Receive Profiles",
    "MQTT Send Profiles": "MQTT Send Profiles",
    "MQTT Receive Profiles": "MQTT Receive Profiles",
    "MQTT Send Profile": "MQTT Send Profile",
    "MQTT Receive Profile": "MQTT Receive Profile",
    "Receive JSON": "Receive JSON",
    "Define the publish Topic and outgoing payload. A Tag may override the Connection Send Profile.":
      "Define the publish Topic and outgoing payload. A Tag may override the Connection Send Profile.",
    Topic: "Topic",
    Payload: "Payload",
    "Raw value": "Raw value",
    "Raw Value": "Raw Value",
    "Built-in": "Built-in",
    "Profile updated": "Profile updated",
    "Profile created": "Profile created",
    "Profile deleted": "Profile deleted",
    "Profile applied": "Profile applied",
    "Edit MQTT Send Profile": "Edit MQTT Send Profile",
    "Create MQTT Send Profile": "Create MQTT Send Profile",
    "Edit MQTT Receive Profile": "Edit MQTT Receive Profile",
    "Create MQTT Receive Profile": "Create MQTT Receive Profile",
    "Payload Type": "Payload Type",
    "Payload Format": "Payload Format",
    "Custom template": "Custom template",
    "Supported:": "Supported:",
    "JSON is optional. Supported:": "JSON is optional. Supported:",
    "One profile can contain multiple Topic rules. Each message selects one rule and is parsed once.":
      "One profile can contain multiple Topic rules. Each message selects one rule and is parsed once.",
    Rules: "Rules",
    Rule: "Rule",
    Parsers: "Parsers",
    Duplicate: "Duplicate",
    Copy: "Copy",
    "Profile information": "Profile information",
    View: "View",
    "View MQTT Receive Profile": "View MQTT Receive Profile",
    "Saved configuration": "Saved configuration",
    "Detected configuration": "Detected configuration",
    "Configuration version": "Configuration version",
    "Saved example payload": "Saved example payload",
    "Technical configuration": "Technical configuration",
    "Data Key and Value fields": "Data Key and Value fields",
    "Built-in Profiles are read-only. The rules and examples below show exactly how incoming payloads are parsed.":
      "Built-in Profiles are read-only. The rules and examples below show exactly how incoming payloads are parsed.",
    "Information used to identify the Profile when assigning it to an MQTT Connection.":
      "Information used to identify the Profile when assigning it to an MQTT Connection.",
    "Each message is processed by the best matching rule only. Use a real sample and Test Rule before saving.":
      "Each message is processed by the best matching rule only. Use a real sample and Test Rule before saving.",
    "Add Rule": "Add Rule",
    "Apply Profile": "Apply Profile",
    Remove: "Remove",
    "Rule Name": "Rule Name",
    "Profile Name": "Profile Name",
    Priority: "Priority",
    "Topic Filter": "Topic Filter",
    Parser: "Parser",
    "1. Rule setup": "1. Rule setup",
    "2. Paste payload and detect": "2. Paste payload and detect",
    "2. Detect JSON structure": "2. Detect JSON structure",
    "2. Detect and test JSON": "2. Detect and test JSON",
    "Use the same Topic and Payload box: detect the structure first, then replace the payload and run a test.":
      "Use the same Topic and Payload box: detect the structure first, then replace the payload and run a test.",
    "3. Test with another payload": "3. Test with another payload",
    "2. Paste payload and test": "2. Paste payload and test",
    "Set the rule name, Topic, and parser used to receive data.":
      "Set the rule name, Topic, and parser used to receive data.",
    "Raw Value target": "Raw Value target",
    "A Raw payload has no Data Key inside it. Select the Tag Data Key here or capture it from the Topic.":
      "A Raw payload has no Data Key inside it. Select the Tag Data Key here or capture it from the Topic.",
    "One Tag": "One Tag",
    "Many Tags": "Many Tags",
    "Connection Client ID": "Connection Client ID",
    "use an exact Topic Filter and enter one fixed Data Key.":
      "use an exact Topic Filter and enter one fixed Data Key.",
    "use a named {dataKey} segment in Topic Filter and select Data Key from Topic.":
      "use a named {dataKey} segment in Topic Filter and select Data Key from Topic.",
    "Fixed Data Key": "Fixed Data Key",
    "Data Key from Topic": "Data Key from Topic",
    "Tag Data Key": "Tag Data Key",
    "Topic Filter contains the Data Key capture.": "Topic Filter contains the Data Key capture.",
    "Example Topic Filter: devices/pump/{dataKey}": "Example Topic Filter: devices/pump/{dataKey}",
    "Enter the Tag Data Key that receives this Raw value.": "Enter the Tag Data Key that receives this Raw value.",
    "Enter a Data Key capture name.": "Enter a Data Key capture name.",
    "Topic Filter must contain the selected Data Key capture.":
      "Topic Filter must contain the selected Data Key capture.",
    "Paste a real device payload. JSON is analyzed automatically and Preview shows the detected Tag values.":
      "Paste a real device payload. JSON is analyzed automatically and Preview shows the detected Tag values.",
    "Advanced parser settings": "Advanced parser settings",
    "Optional manual mapping for advanced users": "Optional manual mapping for advanced users",
    "Manual payload mapping": "Manual payload mapping",
    "Normally you do not need this section. Use it only to override the mapping detected from the sample payload.":
      "Normally you do not need this section. Use it only to override the mapping detected from the sample payload.",
    "Data format settings": "Data format settings",
    "Required for the selected non-JSON parser": "Required for the selected non-JSON parser",
    "Paste one real payload. The system detects the fields automatically; review their roles before testing.":
      "Paste one real payload. The system detects the fields automatically; review their roles before testing.",
    "Paste a second payload with the same structure. This test uses the detected rule exactly as Runtime will use it.":
      "Paste a second payload with the same structure. This test uses the detected rule exactly as Runtime will use it.",
    "Paste real device data to test before applying the Profile.":
      "Paste real device data to test before applying the Profile.",
    "Detected JSON fields": "Detected JSON fields",
    "Confirm what each field means. The suggested roles can be changed.":
      "Confirm what each field means. The suggested roles can be changed.",
    "JSON field": "JSON field",
    "Sample value": "Sample value",
    "Field role": "Field role",
    "Tag value — field name is Data Key": "Tag value — field name is Data Key",
    "Data Key field": "Data Key field",
    "Value field": "Value field",
    "Timestamp field": "Timestamp field",
    "Group field": "Group field",
    "Ignore this field": "Ignore this field",
    "Example temp: 12.5 — temp is matched directly to a Tag Data Key.":
      "Example temp: 12.5 — temp is matched directly to a Tag Data Key.",
    "The field contains the Data Key text and must be paired with one Value field.":
      "The field contains the Data Key text and must be paired with one Value field.",
    "The field contains the Tag value and must be paired with one Data Key field.":
      "The field contains the Tag value and must be paired with one Data Key field.",
    "Message time in Unix seconds, Unix milliseconds, or ISO 8601.":
      "Message time in Unix seconds, Unix milliseconds, or ISO 8601.",
    "The field identifies the Tag Group or device group for the received values.":
      "The field identifies the Tag Group or device group for the received values.",
    "Keep the field out of Tag matching and stored values.": "Keep the field out of Tag matching and stored values.",
    "Test Topic": "Test Topic",
    "Test Payload": "Test Payload",
    "Detect fields": "Detect fields",
    "Analyzing...": "Analyzing...",
    "Testing...": "Testing...",
    "Run payload test": "Run payload test",
    "Confirm roles and preview": "Confirm roles and preview",
    "Test passed: the payload produced Tag values": "Test passed: the payload produced Tag values",
    "Run a successful test before applying the Profile": "Run a successful test before applying the Profile",
    "Test or preview every enabled rule successfully before applying the Profile.": "Test or preview every enabled rule successfully before applying the Profile.",
    "The test payload did not produce any Tag values. Check the detected field roles and Topic.":
      "The test payload did not produce any Tag values. Check the detected field roles and Topic.",
    "The sample payload did not produce any Tag values. Check the detected field roles.":
      "The sample payload did not produce any Tag values. Check the detected field roles.",
    "Only one Timestamp and one Group field can be selected.": "Only one Timestamp and one Group field can be selected.",
    "Select exactly one Data Key field and one Value field.": "Select exactly one Data Key field and one Value field.",
    "Data Key and Value must belong to the same JSON record.": "Data Key and Value must belong to the same JSON record.",
    "Data Key and Value must belong to the same JSON array.": "Data Key and Value must belong to the same JSON array.",
    "Select at least one Tag Value field, or select a Data Key and Value pair.":
      "Select at least one Tag Value field, or select a Data Key and Value pair.",
    "Tag Value fields must belong to the same JSON object.": "Tag Value fields must belong to the same JSON object.",
    number: "number",
    string: "string",
    boolean: "boolean",
    null: "null",
    object: "object",
    array: "array",
    "JSON — Recommended": "JSON — Recommended",
    "Delimited Key/Value": "Delimited Key/Value",
    "Positional Fields": "Positional Fields",
    "Ready to apply": "Ready to apply",
    "Needs testing": "Needs testing",
    "Data Key": "Data Key",
    "Data Key Source": "Data Key Source",
    Fixed: "Fixed",
    "Topic capture": "Topic capture",
    "Capture Name": "Capture Name",
    Group: "Group",
    "Group Source": "Group Source",
    "No Group": "No Group",
    "Fixed Group": "Fixed Group",
    "Group Capture Name": "Group Capture Name",
    "JSON mapping": "JSON mapping",
    "Data Collection Path": "Data Collection Path",
    "Mapping Mode": "Mapping Mode",
    "Object keys are Data Keys": "Object keys are Data Keys",
    "Array records": "Array records",
    "Fixed field mapping": "Fixed field mapping",
    "Nested dynamic mapping": "Nested dynamic mapping",
    "Group Path": "Group Path",
    "Timestamp Path": "Timestamp Path",
    "Timestamp Format": "Timestamp Format",
    "Root object": "Root object",
    "No group": "No group",
    "Use receive time": "Use receive time",
    "Auto detected": "Auto detected",
    "Unix seconds": "Unix seconds",
    "Unix milliseconds": "Unix milliseconds",
    "Data Key Field": "Data Key Field",
    "Value Field": "Value Field",
    "Record Timestamp Field": "Record Timestamp Field",
    "Record Group Field": "Record Group Field",
    "Detected field → Data Key": "Detected field → Data Key",
    "Item Separator": "Item Separator",
    Separators: "Separators",
    "Metadata Key": "Metadata Key",
    "Key/Value Separator": "Key/Value Separator",
    "Group Metadata Key": "Group Metadata Key",
    "Timestamp Metadata Key": "Timestamp Metadata Key",
    "Field Separator": "Field Separator",
    "Build Fields from Sample": "Build Fields from Sample",
    Timestamp: "Timestamp",
    Ignore: "Ignore",
    Required: "Required",
    "Value conversion": "Value conversion",
    "Value Conversion": "Value Conversion",
    "Convert numeric strings": "Convert numeric strings",
    "Convert Boolean to 0/1": "Convert Boolean to 0/1",
    Sample: "Sample",
    "Sample Topic": "Sample Topic",
    "Sample Payload": "Sample Payload",
    "Add Sample": "Add Sample",
    "Analyze JSON": "Analyze JSON",
    "Test Rule": "Test Rule",
    "Paste a real device payload": "Paste a real device payload",
    "Detected mapping:": "Detected mapping:",
    "Multi-level dynamic mapping": "Multi-level dynamic mapping",
    "Multi-level JSON: dynamic object keys and nested values": "Multi-level JSON: dynamic object keys and nested values",
    "Dynamic key is Data Key": "Dynamic key is Data Key",
    "Dynamic key is Group": "Dynamic key is Group",
    "Each object key identifies a Tag Data Key, for example key and keya.": "Each object key identifies a Tag Data Key, for example key and keya.",
    "Each object key identifies a Group; numeric child field names become Data Keys.": "Each object key identifies a Group; numeric child field names become Data Keys.",
    "Ignore this dynamic level": "Ignore this dynamic level",
    "Traverse this level without using its key for Tag matching.": "Traverse this level without using its key for Tag matching.",
    "JSON container": "JSON container",
    "This node only contains lower-level fields and does not create a Tag value.": "This node only contains lower-level fields and does not create a Tag value.",
    "Ignore this branch": "Ignore this branch",
    "Do not use this container itself as Tag data.": "Do not use this container itself as Tag data.",
    "dynamic keys": "dynamic keys",
    "array item": "array item",
    "Rule tested with the current configuration": "Rule tested with the current configuration",
    "Test this rule before Apply Profile": "Test this rule before Apply Profile",
    "Advanced generated configuration": "Advanced generated configuration",
    "Topic did not match this rule.": "Topic did not match this rule.",
    "No Tag values were produced.": "No Tag values were produced.",
    "Legacy JSON Template 1": "Legacy JSON Template 1",
    "Legacy JSON Template 2": "Legacy JSON Template 2",
    "Legacy JSON Template 3": "Legacy JSON Template 3",
    "Array records: each item contains a Data Key and value": "Array records: each item contains a Data Key and value",
    "Flat JSON object: property names become Data Keys": "Flat JSON object: property names become Data Keys",
    "Fixed JSON fields mapped to Data Keys": "Fixed JSON fields mapped to Data Keys",
    "Object map at": "Object map at",
    "property names become Data Keys": "property names become Data Keys",
    "Array records at": "Array records at",
    "Help for": "Help for",
    optional: "optional",
    "Publish the value unchanged for compatibility with existing devices.":
      "Publish the value unchanged for compatibility with existing devices.",
    "Publish an identifiable JSON command containing the MQTT Tag data key.":
      "Publish an identifiable JSON command containing the MQTT Tag data key.",
    "Publish the raw value on a topic containing the Tag data key.":
      "Publish the raw value on a topic containing the Tag data key.",
    "Parse the existing MQTT envelope templates 1–3.": "Parse the existing MQTT envelope templates 1–3.",
    "Parse a flat JSON object whose keys are Tag Data Keys.": "Parse a flat JSON object whose keys are Tag Data Keys.",
    "Parse key/value items separated by configurable characters.": "Parse key/value items separated by configurable characters.",
    "Parse one numeric or Boolean value using a fixed Data Key.": "Parse one numeric or Boolean value using a fixed Data Key.",
    "Parse values from fixed positions separated by a configurable character.":
      "Parse values from fixed positions separated by a configurable character.",
    "Switch to English": "Switch to English",
    "Switch to Vietnamese": "Switch to Vietnamese",
  },
  vi: {
    Dashboard: "Bảng điều khiển",
    Dashboards: "Bảng điều khiển",
    Monitorings: "Màn hình giám sát",
    "Project Manager": "Quản lý Project",
    "Project Runtime": "Chạy Project",
    "Runtime Diagnostics": "Chẩn đoán Runtime",
    Screens: "Màn hình",
    Reports: "Báo cáo",
    History: "Lịch sử",
    Records: "Bản ghi",
    "Alarm Manager": "Quản lý Alarm",
    "Alert Manager": "Quản lý Alarm",
    Manual: "Hướng dẫn",
    Settings: "Cài đặt",
    Connections: "Kết nối",
    "Tag Groups": "Nhóm tag",
    Accounts: "Tài khoản",
    System: "Hệ thống",
    Alarms: "Alarm",
    Alerts: "Alarm",
    alarms: "alarm",
    alerts: "alarm",
    dashboard: "bảng điều khiển",
    history: "lịch sử",
    records: "bản ghi",
    manual: "hướng dẫn",
    connections: "kết nối",
    "tag groups": "nhóm tag",
    accounts: "tài khoản",
    system: "hệ thống",
    "alarm reports": "báo cáo alarm",
    "alert reports": "báo cáo alarm",
    "Alert Reports": "Báo cáo Alarm",
    Alert: "Alarm",
    "Alert:": "Alarm:",
    State: "Trạng thái",
    "State:": "Trạng thái:",
    Started: "Bắt đầu",
    Ended: "Kết thúc",
    Viewed: "Đã xem",
    Duration: "Thời lượng",
    Total: "Tổng",
    Active: "Đang hoạt động",
    Summary: "Tổng quan",
    "Active Alerts": "Alarm đang hoạt động",
    "All Active Alerts": "Tất cả alarm đang hoạt động",
    "Alert History": "Lịch sử alarm",
    "Alert Summary": "Tổng quan alarm",
    "Filter by alert": "Lọc theo alarm",
    "Click one alert row to filter its history": "Bấm vào một dòng alarm để lọc lịch sử của nó",
    "Alert Detail": "Chi tiết alarm",
    "Start value:": "Giá trị bắt đầu:",
    "End value:": "Giá trị kết thúc:",
    "Start data:": "Dữ liệu lúc bắt đầu:",
    "End data:": "Dữ liệu lúc kết thúc:",
    "Historical Alert Type": "Phiên bản Alarm Type lúc đó",
    "Historical Alert Tag": "Phiên bản Alarm Tag lúc đó",
    "Historical Configuration": "Cấu hình lịch sử",
    "Source Tags": "Các tag nguồn",
    "Marked as viewed": "Đánh dấu đã xem",
    Note: "Ghi chú",
    "Unable to load alert detail": "Không thể tải chi tiết alarm",
    "Alert record updated": "Đã cập nhật bản ghi alarm",
    "Alert records cleared": "Đã xóa bản ghi alarm",
    "Unable to update alert record": "Không thể cập nhật bản ghi alarm",
    "Unable to clear alert records": "Không thể xóa bản ghi alarm",
    "load failed": "tải thất bại",
    "update failed": "cập nhật thất bại",
    "update succeeded": "cập nhật thành công",
    "Alert Types": "Loại Alarm",
    "Alert Tags": "Tag Alarm",
    "Alert Type": "Loại Alarm",
    "Alert Tag": "Tag Alarm",
    Language: "Ngôn ngữ",
    English: "English",
    Vietnamese: "Tiếng Việt",
    "Hi,": "Xin chào,",
    "Loading...": "Đang tải...",
    "New Type": "Tạo loại mới",
    "New Alert Tag": "Tạo tag alarm",
    "Create a new alert type, then open it to configure values and states.":
      "Tạo loại alarm mới, sau đó mở ra để cấu hình giá trị so sánh và các trạng thái.",
    "Please input data for new alert tag": "Vui lòng nhập thông tin cho tag alarm mới",
    "Please input data for new tag": "Vui lòng nhập thông tin cho tag mới",
    "BASIC INFORMATION": "THÔNG TIN CƠ BẢN",
    Close: "Đóng",
    Save: "Lưu",
    Name: "Tên",
    Description: "Mô tả",
    "Filter Name": "Lọc theo tên",
    "Filter Alert Type": "Lọc theo loại alarm",
    "Search by name": "Tìm theo tên",
    Search: "Tìm kiếm",
    "All Alert Types": "Tất cả loại alarm",
    "Select alert type": "Chọn loại alarm",
    "Source Tag": "Tag nguồn",
    Tag: "Tag",
    "Tag Group": "Nhóm tag",
    "All Tag Groups": "Tất cả nhóm tag",
    "Select source tag": "Chọn tag nguồn",
    "Select tag": "Chọn tag",
    "Save Alert Tag": "Lưu tag alarm",
    Versions: "Phiên bản",
    Version: "Phiên bản",
    "Created At": "Thời gian tạo",
    "Tag Versions": "Phiên bản tag",
    Current: "Hiện tại",
    Unused: "Chưa dùng",
    "In use": "Đang được dùng",
    "Delete version": "Xóa phiên bản",
    "This version is still in use": "Phiên bản này vẫn đang được sử dụng",
    "Are you sure you want to delete this version?": "Bạn có chắc muốn xóa phiên bản này?",
    "Alert type version deleted": "Đã xóa phiên bản alarm type",
    "Unable to delete alert type version": "Không thể xóa phiên bản alarm type",
    "Alert tag version deleted": "Đã xóa phiên bản alarm tag",
    "Unable to delete alert tag version": "Không thể xóa phiên bản alarm tag",
    "Old versions can be deleted only when they are no longer referenced by alert records or alert tag versions.":
      "Chỉ có thể xóa các phiên bản cũ khi chúng không còn bị bản ghi alarm hoặc phiên bản alarm tag tham chiếu.",
    "Old versions can be deleted only when they are no longer referenced by alert records.":
      "Chỉ có thể xóa các phiên bản cũ khi chúng không còn bị bản ghi alarm tham chiếu.",
    "Alert Type Version": "Phiên bản Alarm Type",
    "Loading alert tag...": "Đang tải tag alarm...",
    "Loading alert type...": "Đang tải loại alarm...",
    "Loading alert settings...": "Đang tải cấu hình alarm...",
    "Current State": "Trạng thái hiện tại",
    Inactive: "Không kích hoạt",
    Normal: "Bình Thường",
    "matched states": "trạng thái đúng",
    states: "trạng thái",
    Action: "Thao tác",
    Delete: "Xóa",
    "Are you sure you want to delete alert type with Name:":
      "Bạn có chắc muốn xóa loại alarm có tên:",
    "Are you sure you want to delete alert tag with Name:":
      "Bạn có chắc muốn xóa tag alarm có tên:",
    Edit: "Sửa",
    "Compare Values": "Giá trị so sánh",
    States: "Trạng thái",
    "Click one alert type to open its own page for compare values, states, and simulation.":
      "Bấm vào một loại alarm để mở trang riêng cấu hình giá trị so sánh, trạng thái và mô phỏng.",
    "Tạo alert tag cơ bản trước, sau đó bấm vào từng dòng để cấu hình tag group, tag nguồn, và các thông số.":
      "Tạo tag alarm cơ bản trước, sau đó bấm vào từng dòng để cấu hình nhóm tag, tag nguồn và các thông số.",
    "1. Thông tin cơ bản": "1. Thông tin cơ bản",
    "2. Alert parameters": "2. Thông số alarm",
    "2. Source Tag": "2. Tag nguồn",
    "3. Thông số cảnh báo": "3. Thông số alarm",
    "Chọn tag group, source tag, và các thông số so sánh cho cảnh báo này.":
      "Chọn nhóm tag, tag nguồn và các thông số so sánh cho alarm này.",
    "Alert output tag đã được tạo tự động trong nhóm `Alerts`. Ở đây bạn chọn tag nguồn để so sánh.":
      "Tag đầu ra của alarm đã được tạo tự động trong nhóm `Alarms`. Tại đây bạn chọn tag nguồn để so sánh.",
    "Các giá trị bên dưới sẽ được dùng trong condition của alert type đã chọn.":
      "Các giá trị bên dưới sẽ được dùng trong điều kiện của loại alarm đã chọn.",
    "Alert type này hiện chưa có compare values.":
      "Loại alarm này hiện chưa có giá trị so sánh.",
    "Enter alert tag name": "Nhập tên tag alarm",
    "Enter alert type name": "Nhập tên loại alarm",
    "Enter description": "Nhập mô tả",
    "1. Tạo giá trị để so sánh": "1. Tạo giá trị để so sánh",
    "2. Tạo States": "2. Tạo trạng thái",
    "3. Giả lập ngõ ra": "3. Giả lập ngõ ra",
    Key: "Key",
    Order: "Thứ tự",
    Message: "Thông báo",
    Color: "Màu sắc",
    Condition: "Điều kiện",
    "No description": "Chưa có mô tả",
    "Add Value": "Thêm giá trị",
    "Add Tag": "Thêm tag",
    "Add Compare": "Thêm so sánh",
    "Update Compare": "Cập nhật so sánh",
    "Save Values": "Lưu giá trị",
    "Save Changes": "Lưu thay đổi",
    "Update State": "Cập nhật state",
    "Create State": "Tạo state",
    "Cancel Edit": "Hủy sửa",
    "Please create or cancel the current state before saving changes.":
      "Vui lòng tạo hoặc hủy state đang chỉnh sửa trước khi lưu thay đổi.",
    "Please add or cancel the current compare before saving changes.":
      "Vui lòng thêm hoặc hủy compare hiện tại trước khi lưu thay đổi.",
    "Unsaved changes": "Thay đổi chưa lưu",
    "You have unsaved changes. Continue without saving?": "Bạn có thay đổi chưa lưu. Vẫn tiếp tục thoát?",
    Stay: "Ở lại",
    Continue: "Tiếp tục",
    "Current Output": "Ngõ ra hiện tại",
    Matched: "Khớp",
    "No active state.": "Không có state nào active.",
    "Allowed params:": "Biến được phép:",
    "Operators:": "Phép toán:",
    "Condition error:": "Lỗi điều kiện:",
    "Condition references a key that does not exist:": "Điều kiện đang dùng key không tồn tại:",
    "Each compare value is used in state conditions and in the Alert Tag form.":
      "Mỗi giá trị so sánh sẽ được dùng trong condition của state và trong form Alarm Tag.",
    "Value inputs are entered manually in Alert Tag. Tag inputs let the user choose a real tag and expose its value by key in conditions.":
      "Các input kiểu giá trị sẽ nhập tay trong Alarm Tag. Các input kiểu tag sẽ cho người dùng chọn tag thực và dùng giá trị của tag đó theo key trong condition.",
    "Keys can only use letters, numbers, hyphens, and underscores. Example: `high`, `critical_1`, `limit-max`.":
      "Key chỉ được dùng chữ cái, số, dấu gạch ngang và gạch dưới. Ví dụ: `high`, `critical_1`, `limit-max`.",
    "Key `value` is reserved for source tag data and cannot be used as a compare value.":
      "Key `value` là biến dành riêng cho dữ liệu từ tag nguồn nên không được dùng làm giá trị so sánh.",
    "Conditions can use the keys created above. The first matching state becomes the active output.":
      "Condition được phép dùng các key đã tạo ở phần trên. State đầu tiên match sẽ là ngõ ra active.",
    "Conditions can use the keys created above. Any matching state will be shown in the simulation output.":
      "Condition được phép dùng các key đã tạo ở phần trên. Mọi state khớp sẽ được hiển thị trong phần mô phỏng.",
    "Example: High Value": "Ví dụ: Giá trị cao",
    "Example: Temperature Tag": "Ví dụ: Tag nhiệt độ",
    "Example: high": "Ví dụ: high",
    "Example: temperature": "Ví dụ: temperature",
    "Example: Temperature is above threshold": "Ví dụ: Nhiệt độ vượt ngưỡng",
    "Example: `temperature > high && pressure < critical`": "Ví dụ: `temperature > high && pressure < critical`",
    "Example: temperature > high && pressure < critical": "Ví dụ: temperature > high && pressure < critical",
    "Enter values for the inputs below to see which state becomes active.":
      "Nhập các giá trị bên dưới để kiểm tra state nào sẽ active.",
    "Configure numeric values and source tags for each key used by this alert type.":
      "Cấu hình giá trị số và tag nguồn cho từng key mà loại alarm này sử dụng.",
    "Alert type must include at least one tag input.":
      "Loại alarm phải có ít nhất một trường kiểu tag.",
    "Please enter a key for at least one tag input.":
      "Vui lòng nhập key cho ít nhất một trường kiểu tag.",
    "Please select all required tags.": "Vui lòng chọn đầy đủ các tag bắt buộc.",
    "Needs update": "Cần cập nhật",
    "Alert type updated. Related alert tags were disabled and need review before alerts work again.":
      "Alarm type đã được cập nhật. Các alarm tag liên quan đã bị tắt và cần được kiểm tra, lưu lại trước khi alarm hoạt động lại.",
    "This alert tag is disabled and must be reviewed before alerts work again.":
      "Alarm tag này đang bị vô hiệu và cần được kiểm tra lại trước khi alarm hoạt động trở lại.",
    "Please review the parameters below and save again to reactivate this alert tag.":
      "Vui lòng kiểm tra lại các thông số bên dưới rồi lưu lại để kích hoạt lại alarm tag này.",
    create: "tạo mới",
    update: "cập nhật",
    detail: "chi tiết",
    "display profiles": "cấu hình hiển thị",
    "Display Profiles": "Cấu hình hiển thị",
    Create: "Tạo mới",
    Update: "Cập nhật",
    Cancel: "Hủy",
    All: "Tất cả",
    Yes: "Đồng ý",
    No: "Không",
    Tags: "Tags",
    Connections: "Kết nối",
    Connection: "Kết nối",
    Port: "Cổng",
    Type: "Loại",
    Status: "Trạng thái",
    "Status At": "Thời điểm trạng thái",
    "Data Key": "Khóa dữ liệu",
    "Data Key Enabled": "Bật khóa dữ liệu",
    Enabled: "Bật",
    Disabled: "Tắt",
    "BG Image": "Ảnh nền",
    "Protocol (Method)": "Giao thức (Phương thức)",
    "Protocol (Methods)": "Giao thức (Phương thức)",
    "Select Port": "Chọn cổng",
    "Select Type": "Chọn loại",
    "Select Column": "Chọn cột",
    "Select Connection": "Chọn kết nối",
    "Select Tag": "Chọn tag",
    "Select Tag Group": "Chọn nhóm tag",
    "Select tag group": "Chọn nhóm tag",
    "Select tags": "Chọn tags",
    "Select tag group first": "Hãy chọn nhóm tag trước",
    "Type here to search...": "Nhập để tìm kiếm...",
    "Columns Filter": "Bộ lọc cột",
    Value: "Giá trị",
    Time: "Thời gian",
    "Date Time": "Ngày giờ",
    "Connections Management": "Quản lý kết nối",
    "Tag Groups Management": "Quản lý nhóm tag",
    "Modbus TCP, RTU connections": "Các kết nối Modbus TCP, RTU",
    "Groups,Tags": "Nhóm,Tags",
    "NEW CONNECTION": "TẠO KẾT NỐI MỚI",
    "Create Connection": "Tạo kết nối",
    "Please provide data for new connection": "Vui lòng nhập thông tin cho kết nối mới",
    "NEW TAG GROUP": "TẠO NHÓM TAG MỚI",
    "Please input data for new tag group": "Vui lòng nhập thông tin cho nhóm tag mới",
    "Enter name": "Nhập tên",
    "Enter description": "Nhập mô tả",
    "Enter host": "Nhập host",
    "Enter data key": "Nhập khóa dữ liệu",
    "Select Connection Type": "Chọn loại kết nối",
    "Slave Id": "Slave Id",
    "TCP Host": "TCP Host",
    "TCP Port": "TCP Port",
    "Poll Time": "Chu kỳ đọc",
    "Connect And Read Timeout (s)": "Thời gian chờ kết nối và đọc (giây)",
    "Block Reading Max Size": "Kích thước đọc khối tối đa",
    "DELETE CONNECTION": "XÓA KẾT NỐI",
    "DELETE TAG": "XÓA NHÓM TAG",
    "Are you sure you want to delete connection with Name:":
      "Bạn có chắc muốn xóa kết nối có tên:",
    "Are you sure you want to delete tag group with Name:":
      "Bạn có chắc muốn xóa nhóm tag có tên:",
    online: "trực tuyến",
    offline: "ngoại tuyến",
    unknown: "không rõ",
    MONITORINGS: "MÀN HÌNH GIÁM SÁT",
    HISTORY: "LỊCH SỬ",
    RECORDS: "BẢN GHI",
    "USAGE RECORDS": "THỐNG KÊ BẢN GHI",
    "GRID DATA": "DỮ LIỆU BẢNG",
    "Data Buckets": "Các bucket dữ liệu",
    "No bucket": "Không có bucket",
    "Chart View": "Biểu đồ",
    "Grid View": "Dạng bảng",
    "Delete Searched Range": "Xóa vùng đã tìm",
    "Delete searched history records?": "Xóa dữ liệu lịch sử đã tìm?",
    "This action permanently deletes history records for the selected tags in the selected time range.":
      "Thao tác này sẽ xóa vĩnh viễn dữ liệu lịch sử của các tag đã chọn trong khoảng thời gian đã chọn.",
    "Loaded bucket records:": "Số bản ghi bucket đã tải:",
    "Record counts will refresh after deletion. Empty storage segments are removed so disk usage can shrink.":
      "Số lượng bản ghi sẽ được làm mới sau khi xóa. Các vùng lưu trữ trống sẽ được dọn để dung lượng đĩa có thể giảm.",
    "Type DELETE to confirm.": "Nhập DELETE để xác nhận.",
    "Delete Records": "Xóa bản ghi",
    "Selected range:": "Khoảng đã chọn:",
    "loaded bucket records": "bản ghi bucket đã tải",
    "Max selection: 16 Tags": "Chọn tối đa: 16 Tags",
    "Clear All": "Xóa toàn bộ",
    "Clear Before": "Xóa trước thời điểm",
    "clearing...": "đang xóa...",
    "EST: 10m": "Ước tính: 10p",
    "CLEAR RECORDS": "XÓA BẢN GHI",
    "Are you sure you want to clear all records of:":
      "Bạn có chắc muốn xóa toàn bộ bản ghi của:",
    "Are you sure you want to clear records before time of:":
      "Bạn có chắc muốn xóa các bản ghi trước thời điểm của:",
    "Total Rows:": "Tổng số dòng:",
    "There are no rows please select tag and fetch data first":
      "Hiện chưa có dòng dữ liệu, hãy chọn tag và tải dữ liệu trước",
    "Records Total": "Tổng số bản ghi",
    Communications: "Truyền thông",
    Interfaces: "Giao diện kết nối",
    Protocol: "Giao thức",
    "MQTT Profiles": "Cấu hình MQTT",
    "Send Profiles": "Cấu hình gửi",
    "Receive Profiles": "Cấu hình nhận",
    "MQTT Send Profiles": "Cấu hình gửi MQTT",
    "MQTT Receive Profiles": "Cấu hình nhận MQTT",
    "MQTT Send Profile": "Cấu hình gửi MQTT",
    "MQTT Receive Profile": "Cấu hình nhận MQTT",
    "Receive JSON": "Nhận JSON",
    "Define the publish Topic and outgoing payload. A Tag may override the Connection Send Profile.":
      "Khai báo Topic publish và payload gửi đi. Tag có thể ghi đè cấu hình gửi của Connection.",
    Topic: "Topic",
    Payload: "Payload",
    "Raw value": "Giá trị thô",
    "Raw Value": "Giá trị thô",
    "Built-in": "Có sẵn",
    "Profile updated": "Đã cập nhật cấu hình",
    "Profile created": "Đã tạo cấu hình",
    "Profile deleted": "Đã xóa cấu hình",
    "Profile applied": "Đã áp dụng cấu hình",
    "Edit MQTT Send Profile": "Sửa cấu hình gửi MQTT",
    "Create MQTT Send Profile": "Tạo cấu hình gửi MQTT",
    "Edit MQTT Receive Profile": "Sửa cấu hình nhận MQTT",
    "Create MQTT Receive Profile": "Tạo cấu hình nhận MQTT",
    "Payload Type": "Kiểu payload",
    "Payload Format": "Định dạng payload",
    "Custom template": "Mẫu tùy chỉnh",
    "Supported:": "Hỗ trợ:",
    "JSON is optional. Supported:": "Không bắt buộc dùng JSON. Hỗ trợ:",
    "One profile can contain multiple Topic rules. Each message selects one rule and is parsed once.":
      "Một cấu hình có thể chứa nhiều rule Topic. Mỗi message chỉ chọn một rule và được phân tích một lần.",
    Rules: "Các rule",
    Rule: "Rule",
    Parsers: "Bộ phân tích",
    Duplicate: "Nhân bản",
    Copy: "Bản sao",
    "Profile information": "Thông tin cấu hình",
    View: "Xem",
    "View MQTT Receive Profile": "Xem cấu hình nhận MQTT",
    "Saved configuration": "Cấu hình đã lưu",
    "Detected configuration": "Cấu hình đã nhận dạng",
    "Configuration version": "Phiên bản cấu hình",
    "Saved example payload": "Payload mẫu đã lưu",
    "Technical configuration": "Cấu hình kỹ thuật",
    "Data Key and Value fields": "Các trường Data Key và giá trị",
    "Built-in Profiles are read-only. The rules and examples below show exactly how incoming payloads are parsed.":
      "Profile có sẵn chỉ được xem. Các rule và ví dụ bên dưới cho biết chính xác payload nhận vào được phân tích như thế nào.",
    "Information used to identify the Profile when assigning it to an MQTT Connection.":
      "Thông tin dùng để nhận biết cấu hình khi gán cho MQTT Connection.",
    "Each message is processed by the best matching rule only. Use a real sample and Test Rule before saving.":
      "Mỗi message chỉ được xử lý bởi một rule phù hợp nhất. Hãy dùng sample thật và kiểm tra rule trước khi lưu.",
    "Add Rule": "Thêm rule",
    "Apply Profile": "Áp dụng cấu hình",
    Remove: "Xóa",
    "Rule Name": "Tên rule",
    "Profile Name": "Tên cấu hình",
    Priority: "Độ ưu tiên",
    "Topic Filter": "Bộ lọc Topic",
    Parser: "Bộ phân tích",
    "1. Rule setup": "1. Thiết lập rule",
    "2. Paste payload and detect": "2. Dán payload và tự nhận dạng",
    "2. Detect JSON structure": "2. Nhận dạng cấu trúc JSON",
    "2. Detect and test JSON": "2. Nhận dạng và chạy thử JSON",
    "Use the same Topic and Payload box: detect the structure first, then replace the payload and run a test.":
      "Dùng chung ô Topic và Payload: nhận dạng cấu trúc trước, sau đó thay payload khác và chạy thử.",
    "3. Test with another payload": "3. Chạy thử bằng payload khác",
    "2. Paste payload and test": "2. Dán payload và chạy thử",
    "Set the rule name, Topic, and parser used to receive data.":
      "Đặt tên, chọn Topic và bộ phân tích dùng để nhận dữ liệu.",
    "Raw Value target": "Đích nhận giá trị Raw",
    "A Raw payload has no Data Key inside it. Select the Tag Data Key here or capture it from the Topic.":
      "Payload Raw không chứa Data Key. Hãy chọn Data Key của Tag nhận dữ liệu hoặc lấy Data Key từ Topic.",
    "One Tag": "Một Tag",
    "Many Tags": "Nhiều Tag",
    "Connection Client ID": "Client ID của Connection",
    "use an exact Topic Filter and enter one fixed Data Key.":
      "dùng Topic Filter chính xác và nhập một Data Key cố định.",
    "use a named {dataKey} segment in Topic Filter and select Data Key from Topic.":
      "dùng vùng {dataKey} trong Topic Filter và chọn lấy Data Key từ Topic.",
    "Fixed Data Key": "Data Key cố định",
    "Data Key from Topic": "Lấy Data Key từ Topic",
    "Tag Data Key": "Data Key của Tag",
    "Topic Filter contains the Data Key capture.": "Topic Filter đã chứa vùng Data Key.",
    "Example Topic Filter: devices/pump/{dataKey}": "Ví dụ Topic Filter: devices/pump/{dataKey}",
    "Enter the Tag Data Key that receives this Raw value.": "Hãy nhập Data Key của Tag nhận giá trị Raw này.",
    "Enter a Data Key capture name.": "Hãy nhập tên vùng lấy Data Key.",
    "Topic Filter must contain the selected Data Key capture.":
      "Topic Filter phải chứa vùng lấy Data Key đã chọn.",
    "Paste a real device payload. JSON is analyzed automatically and Preview shows the detected Tag values.":
      "Dán payload thật của thiết bị. JSON được tự động phân tích và bảng xem trước hiển thị các giá trị Tag đã nhận dạng.",
    "Advanced parser settings": "Cài đặt bộ phân tích nâng cao",
    "Optional manual mapping for advanced users": "Ánh xạ thủ công tùy chọn dành cho người dùng nâng cao",
    "Manual payload mapping": "Ánh xạ payload thủ công",
    "Normally you do not need this section. Use it only to override the mapping detected from the sample payload.":
      "Thông thường không cần dùng phần này. Chỉ mở khi cần chỉnh lại ánh xạ được tự động nhận dạng từ payload mẫu.",
    "Data format settings": "Cài đặt định dạng dữ liệu",
    "Required for the selected non-JSON parser": "Bắt buộc đối với kiểu dữ liệu không phải JSON đã chọn",
    "Paste one real payload. The system detects the fields automatically; review their roles before testing.":
      "Dán một payload thật. Hệ thống tự nhận dạng các trường; hãy kiểm tra lại vai trò trước khi chạy thử.",
    "Paste a second payload with the same structure. This test uses the detected rule exactly as Runtime will use it.":
      "Dán payload thứ hai có cùng cấu trúc. Việc chạy thử sử dụng chính xác rule mà Runtime sẽ sử dụng.",
    "Paste real device data to test before applying the Profile.":
      "Dán dữ liệu thật của thiết bị để chạy thử trước khi áp dụng cấu hình.",
    "Detected JSON fields": "Các trường JSON đã nhận dạng",
    "Confirm what each field means. The suggested roles can be changed.":
      "Xác nhận ý nghĩa của từng trường. Có thể thay đổi vai trò hệ thống đã đề xuất.",
    "JSON field": "Trường JSON",
    "Sample value": "Giá trị mẫu",
    "Field role": "Vai trò",
    "Tag value — field name is Data Key": "Giá trị Tag — tên trường là Data Key",
    "Data Key field": "Trường Data Key",
    "Value field": "Trường giá trị",
    "Timestamp field": "Trường Timestamp",
    "Group field": "Trường Group",
    "Ignore this field": "Bỏ qua trường này",
    "Example temp: 12.5 — temp is matched directly to a Tag Data Key.":
      "Ví dụ temp: 12.5 — temp được đối chiếu trực tiếp với Data Key của Tag.",
    "The field contains the Data Key text and must be paired with one Value field.":
      "Trường này chứa tên Data Key và phải đi cùng một trường giá trị.",
    "The field contains the Tag value and must be paired with one Data Key field.":
      "Trường này chứa giá trị Tag và phải đi cùng một trường Data Key.",
    "Message time in Unix seconds, Unix milliseconds, or ISO 8601.":
      "Thời gian của message theo Unix giây, Unix mili-giây hoặc ISO 8601.",
    "The field identifies the Tag Group or device group for the received values.":
      "Trường này xác định Tag Group hoặc nhóm thiết bị cho các giá trị nhận được.",
    "Keep the field out of Tag matching and stored values.": "Không dùng trường này để ghép Tag hoặc lưu giá trị.",
    "Test Topic": "Topic chạy thử",
    "Test Payload": "Payload chạy thử",
    "Detect fields": "Nhận dạng các trường",
    "Analyzing...": "Đang nhận dạng...",
    "Testing...": "Đang chạy thử...",
    "Run payload test": "Chạy thử payload",
    "Confirm roles and preview": "Xác nhận vai trò và xem trước",
    "Test passed: the payload produced Tag values": "Chạy thử thành công: payload đã tạo được giá trị Tag",
    "Run a successful test before applying the Profile": "Cần chạy thử thành công trước khi áp dụng cấu hình",
    "Test or preview every enabled rule successfully before applying the Profile.": "Cần chạy thử hoặc xem trước thành công tất cả rule đang bật trước khi áp dụng cấu hình.",
    "The test payload did not produce any Tag values. Check the detected field roles and Topic.":
      "Payload chạy thử không tạo được giá trị Tag. Hãy kiểm tra vai trò các trường và Topic.",
    "The sample payload did not produce any Tag values. Check the detected field roles.":
      "Payload mẫu không tạo được giá trị Tag. Hãy kiểm tra lại vai trò các trường.",
    "Only one Timestamp and one Group field can be selected.": "Chỉ được chọn một trường Timestamp và một trường Group.",
    "Select exactly one Data Key field and one Value field.": "Hãy chọn đúng một trường Data Key và một trường giá trị.",
    "Data Key and Value must belong to the same JSON record.": "Data Key và giá trị phải thuộc cùng một bản ghi JSON.",
    "Data Key and Value must belong to the same JSON array.": "Data Key và giá trị phải thuộc cùng một mảng JSON.",
    "Select at least one Tag Value field, or select a Data Key and Value pair.":
      "Hãy chọn ít nhất một trường giá trị Tag, hoặc chọn một cặp Data Key và giá trị.",
    "Tag Value fields must belong to the same JSON object.": "Các trường giá trị Tag phải thuộc cùng một object JSON.",
    number: "số",
    string: "chuỗi",
    boolean: "Boolean",
    null: "rỗng",
    object: "object",
    array: "mảng",
    "JSON — Recommended": "JSON — Khuyên dùng",
    "Delimited Key/Value": "Key/Value phân cách",
    "Positional Fields": "Các trường theo vị trí",
    "Ready to apply": "Sẵn sàng áp dụng",
    "Needs testing": "Cần kiểm tra",
    "Data Key": "Data Key",
    "Data Key Source": "Nguồn Data Key",
    Fixed: "Cố định",
    "Topic capture": "Lấy từ Topic",
    "Capture Name": "Tên vùng lấy dữ liệu",
    Group: "Nhóm",
    "Group Source": "Nguồn Group",
    "No Group": "Không dùng Group",
    "Fixed Group": "Group cố định",
    "Group Capture Name": "Tên vùng lấy Group",
    "JSON mapping": "Ánh xạ JSON",
    "Data Collection Path": "Đường dẫn vùng dữ liệu",
    "Mapping Mode": "Kiểu ánh xạ",
    "Object keys are Data Keys": "Tên thuộc tính là Data Key",
    "Array records": "Danh sách bản ghi",
    "Fixed field mapping": "Ánh xạ trường cố định",
    "Nested dynamic mapping": "Ánh xạ lồng động",
    "Group Path": "Đường dẫn Group",
    "Timestamp Path": "Đường dẫn Timestamp",
    "Timestamp Format": "Định dạng Timestamp",
    "Root object": "Object gốc",
    "No group": "Không dùng group",
    "Use receive time": "Dùng thời điểm nhận",
    "Auto detected": "Tự nhận dạng",
    "Unix seconds": "Unix giây",
    "Unix milliseconds": "Unix mili-giây",
    "Data Key Field": "Trường Data Key",
    "Value Field": "Trường giá trị",
    "Record Timestamp Field": "Trường Timestamp của bản ghi",
    "Record Group Field": "Trường Group của bản ghi",
    "Detected field → Data Key": "Trường phát hiện → Data Key",
    "Item Separator": "Ký tự phân tách mục",
    Separators: "Các ký tự phân tách",
    "Metadata Key": "Key metadata",
    "Key/Value Separator": "Ký tự phân tách Key/Value",
    "Group Metadata Key": "Key metadata Group",
    "Timestamp Metadata Key": "Key metadata Timestamp",
    "Field Separator": "Ký tự phân tách trường",
    "Build Fields from Sample": "Tạo các trường từ dữ liệu mẫu",
    Timestamp: "Timestamp",
    Ignore: "Bỏ qua",
    Required: "Bắt buộc",
    "Value conversion": "Chuyển đổi giá trị",
    "Value Conversion": "Chuyển đổi giá trị",
    "Convert numeric strings": "Chuyển chuỗi số thành number",
    "Convert Boolean to 0/1": "Chuyển Boolean thành 0/1",
    Sample: "Dữ liệu mẫu",
    "Sample Topic": "Topic mẫu",
    "Sample Payload": "Payload mẫu",
    "Add Sample": "Thêm dữ liệu mẫu",
    "Analyze JSON": "Phân tích JSON",
    "Test Rule": "Kiểm tra rule",
    "Paste a real device payload": "Dán payload thật của thiết bị",
    "Detected mapping:": "Ánh xạ phát hiện:",
    "Multi-level dynamic mapping": "Ánh xạ động nhiều tầng",
    "Multi-level JSON: dynamic object keys and nested values": "JSON nhiều tầng: key object động và các giá trị lồng nhau",
    "Dynamic key is Data Key": "Key động là Data Key",
    "Dynamic key is Group": "Key động là Group",
    "Each object key identifies a Tag Data Key, for example key and keya.": "Mỗi key của object xác định một Data Key của Tag, ví dụ key và keya.",
    "Each object key identifies a Group; numeric child field names become Data Keys.": "Mỗi key của object xác định một Group; tên các trường số bên trong trở thành Data Key.",
    "Ignore this dynamic level": "Bỏ qua tầng động này",
    "Traverse this level without using its key for Tag matching.": "Đi qua tầng này nhưng không dùng key của nó để ghép Tag.",
    "JSON container": "Vùng chứa JSON",
    "This node only contains lower-level fields and does not create a Tag value.": "Nút này chỉ chứa các trường cấp dưới và không tạo giá trị Tag.",
    "Ignore this branch": "Bỏ qua nhánh này",
    "Do not use this container itself as Tag data.": "Không dùng chính vùng chứa này làm dữ liệu Tag.",
    "dynamic keys": "các key động",
    "array item": "phần tử mảng",
    "Rule tested with the current configuration": "Rule đã được kiểm tra với cấu hình hiện tại",
    "Test this rule before Apply Profile": "Hãy kiểm tra rule trước khi áp dụng cấu hình",
    "Advanced generated configuration": "Cấu hình nâng cao được tạo",
    "Topic did not match this rule.": "Topic không khớp với rule này.",
    "No Tag values were produced.": "Không tạo được giá trị Tag nào.",
    "Legacy JSON Template 1": "Mẫu JSON legacy 1",
    "Legacy JSON Template 2": "Mẫu JSON legacy 2",
    "Legacy JSON Template 3": "Mẫu JSON legacy 3",
    "Array records: each item contains a Data Key and value": "Danh sách bản ghi: mỗi phần tử chứa Data Key và giá trị",
    "Flat JSON object: property names become Data Keys": "JSON phẳng: tên thuộc tính trở thành Data Key",
    "Fixed JSON fields mapped to Data Keys": "Các trường JSON cố định được ánh xạ thành Data Key",
    "Object map at": "Object Map tại",
    "property names become Data Keys": "tên thuộc tính trở thành Data Key",
    "Array records at": "Danh sách bản ghi tại",
    "Help for": "Hướng dẫn",
    optional: "không bắt buộc",
    "Publish the value unchanged for compatibility with existing devices.":
      "Gửi nguyên giá trị để tương thích với các thiết bị hiện có.",
    "Publish an identifiable JSON command containing the MQTT Tag data key.":
      "Gửi lệnh JSON có chứa Data Key để nhận biết MQTT Tag.",
    "Publish the raw value on a topic containing the Tag data key.":
      "Gửi giá trị thô trên Topic có chứa Data Key của Tag.",
    "Parse the existing MQTT envelope templates 1–3.": "Phân tích các mẫu MQTT legacy 1–3 hiện có.",
    "Parse a flat JSON object whose keys are Tag Data Keys.": "Phân tích JSON phẳng có các key là Data Key của Tag.",
    "Parse key/value items separated by configurable characters.": "Phân tích các mục key/value bằng ký tự phân tách có thể cấu hình.",
    "Parse one numeric or Boolean value using a fixed Data Key.": "Phân tích một giá trị số hoặc Boolean bằng Data Key cố định.",
    "Parse values from fixed positions separated by a configurable character.":
      "Phân tích các giá trị ở vị trí cố định, phân tách bằng ký tự có thể cấu hình.",
    "Optional structure variant": "Biến thể cấu trúc tùy chọn",
    "Add JSON sample": "Thêm mẫu JSON",
    Optional: "Tùy chọn",
    "Topic routing test": "Kiểm tra định tuyến Topic",
    "Enter one real Topic to see every matching rule and which single rule will run.":
      "Nhập một Topic thực tế để xem tất cả rule khớp và rule duy nhất sẽ được chạy.",
    "Check routing": "Kiểm tra định tuyến",
    Selected: "Được chọn",
    "No enabled rule matches this Topic": "Không có rule đang bật nào khớp Topic này",
    "Send Preview": "Xem trước dữ liệu gửi",
    "Generate the exact Topic and payload without publishing anything to MQTT.":
      "Tạo chính xác Topic và payload nhưng không publish dữ liệu lên MQTT.",
    "Client ID": "Client ID",
    "Value type": "Kiểu giá trị",
    Number: "Số",
    String: "Chuỗi",
    Boolean: "Boolean",
    Preview: "Xem trước",
    "Switch to English": "Chuyển sang English",
    "Switch to Vietnamese": "Chuyển sang Tiếng Việt",
  },
};

export const translateText = (text, locale = "en") => {
  if (!text) {
    return text;
  }
  return translations[locale]?.[text] || text;
};
